let U = !1;
const B = [], F = (n) => new Promise((e, t) => {
  if (typeof window > "u" || (window.storyblokRegisterEvent = (s) => {
    if (window.location === window.parent.location) {
      console.warn("You are not in Draft Mode or in the Visual Editor.");
      return;
    }
    U ? s() : B.push(s);
  }, document.getElementById("storyblok-javascript-bridge")))
    return;
  const r = document.createElement("script");
  r.async = !0, r.src = n, r.id = "storyblok-javascript-bridge", r.onerror = (s) => t(s), r.onload = (s) => {
    B.forEach((o) => o()), U = !0, e(s);
  }, document.getElementsByTagName("head")[0].appendChild(r);
});
var re = Object.defineProperty, se = (n, e, t) => e in n ? re(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t, g = (n, e, t) => se(n, typeof e != "symbol" ? e + "" : e, t);
class ne extends Error {
  constructor(e) {
    super(e), this.name = "AbortError";
  }
}
function oe(n, e, t) {
  if (!Number.isFinite(e))
    throw new TypeError("Expected `limit` to be a finite number");
  if (!Number.isFinite(t))
    throw new TypeError("Expected `interval` to be a finite number");
  const r = [];
  let s = [], o = 0, a = !1;
  const l = async () => {
    o++;
    const h = r.shift();
    if (h)
      try {
        const p = await n(...h.args);
        h.resolve(p);
      } catch (p) {
        h.reject(p);
      }
    const d = setTimeout(() => {
      o--, r.length > 0 && l(), s = s.filter((p) => p !== d);
    }, t);
    s.includes(d) || s.push(d);
  }, i = (...h) => a ? Promise.reject(
    new Error(
      "Throttled function is already aborted and not accepting new promises"
    )
  ) : new Promise((d, p) => {
    r.push({
      resolve: d,
      reject: p,
      args: h
    }), o < e && l();
  });
  return i.abort = () => {
    a = !0, s.forEach(clearTimeout), s = [], r.forEach(
      (h) => h.reject(() => new ne("Throttle function aborted"))
    ), r.length = 0;
  }, i;
}
class L {
  constructor() {
    g(this, "isCDNUrl", (e = "") => e.includes("/cdn/")), g(this, "getOptionsPage", (e, t = 25, r = 1) => ({
      ...e,
      per_page: t,
      page: r
    })), g(this, "delay", (e) => new Promise((t) => setTimeout(t, e))), g(this, "arrayFrom", (e = 0, t) => Array.from({ length: e }, t)), g(this, "range", (e = 0, t = e) => {
      const r = Math.abs(t - e) || 0, s = e < t ? 1 : -1;
      return this.arrayFrom(r, (o, a) => a * s + e);
    }), g(this, "asyncMap", async (e, t) => Promise.all(e.map(t))), g(this, "flatMap", (e = [], t) => e.map(t).reduce((r, s) => [...r, ...s], [])), g(this, "escapeHTML", function(e) {
      const t = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
      }, r = /[&<>"']/g, s = new RegExp(r.source);
      return e && s.test(e) ? e.replace(r, (o) => t[o]) : e;
    });
  }
  /**
   * @method stringify
   * @param  {object} params
   * @param  {string} prefix
   * @param  {boolean} isArray
   * @return {string} Stringified object
   */
  stringify(e, t, r) {
    const s = [];
    for (const o in e) {
      if (!Object.prototype.hasOwnProperty.call(e, o))
        continue;
      const a = e[o];
      if (a == null)
        continue;
      const l = r ? "" : encodeURIComponent(o);
      let i;
      typeof a == "object" ? i = this.stringify(
        a,
        t ? t + encodeURIComponent(`[${l}]`) : l,
        Array.isArray(a)
      ) : i = `${t ? t + encodeURIComponent(`[${l}]`) : l}=${encodeURIComponent(a)}`, s.push(i);
    }
    return s.join("&");
  }
  /**
   * @method getRegionURL
   * @param  {string} regionCode region code, could be eu, us, cn, ap or ca
   * @return {string} The base URL of the region
   */
  getRegionURL(e) {
    const t = "api.storyblok.com", r = "api-us.storyblok.com", s = "app.storyblokchina.cn", o = "api-ap.storyblok.com", a = "api-ca.storyblok.com";
    switch (e) {
      case "us":
        return r;
      case "cn":
        return s;
      case "ap":
        return o;
      case "ca":
        return a;
      default:
        return t;
    }
  }
}
const ae = function(n, e) {
  const t = {};
  for (const r in n) {
    const s = n[r];
    e.includes(r) && s !== null && (t[r] = s);
  }
  return t;
}, ie = (n) => n === "email", le = () => ({
  singleTag: "hr"
}), ce = () => ({
  tag: "blockquote"
}), he = () => ({
  tag: "ul"
}), ue = (n) => ({
  tag: [
    "pre",
    {
      tag: "code",
      attrs: n.attrs
    }
  ]
}), de = () => ({
  singleTag: "br"
}), pe = (n) => ({
  tag: `h${n.attrs.level}`
}), ge = (n) => ({
  singleTag: [
    {
      tag: "img",
      attrs: ae(n.attrs, ["src", "alt", "title"])
    }
  ]
}), fe = () => ({
  tag: "li"
}), me = () => ({
  tag: "ol"
}), ye = () => ({
  tag: "p"
}), be = (n) => ({
  tag: [
    {
      tag: "span",
      attrs: {
        "data-type": "emoji",
        "data-name": n.attrs.name,
        emoji: n.attrs.emoji
      }
    }
  ]
}), ke = () => ({
  tag: "b"
}), $e = () => ({
  tag: "s"
}), ve = () => ({
  tag: "u"
}), we = () => ({
  tag: "strong"
}), Te = () => ({
  tag: "code"
}), Re = () => ({
  tag: "i"
}), _e = (n) => {
  if (!n.attrs)
    return {
      tag: ""
    };
  const e = new L().escapeHTML, t = { ...n.attrs }, { linktype: r = "url" } = n.attrs;
  if (delete t.linktype, t.href && (t.href = e(n.attrs.href || "")), ie(r) && (t.href = `mailto:${t.href}`), t.anchor && (t.href = `${t.href}#${t.anchor}`, delete t.anchor), t.custom) {
    for (const s in t.custom)
      t[s] = t.custom[s];
    delete t.custom;
  }
  return {
    tag: [
      {
        tag: "a",
        attrs: t
      }
    ]
  };
}, Ee = (n) => ({
  tag: [
    {
      tag: "span",
      attrs: n.attrs
    }
  ]
}), Se = () => ({
  tag: "sub"
}), je = () => ({
  tag: "sup"
}), Ie = (n) => ({
  tag: [
    {
      tag: "span",
      attrs: n.attrs
    }
  ]
}), xe = (n) => {
  var e;
  return (e = n.attrs) != null && e.color ? {
    tag: [
      {
        tag: "span",
        attrs: {
          style: `background-color:${n.attrs.color};`
        }
      }
    ]
  } : {
    tag: ""
  };
}, Ae = (n) => {
  var e;
  return (e = n.attrs) != null && e.color ? {
    tag: [
      {
        tag: "span",
        attrs: {
          style: `color:${n.attrs.color}`
        }
      }
    ]
  } : {
    tag: ""
  };
}, Oe = {
  nodes: {
    horizontal_rule: le,
    blockquote: ce,
    bullet_list: he,
    code_block: ue,
    hard_break: de,
    heading: pe,
    image: ge,
    list_item: fe,
    ordered_list: me,
    paragraph: ye,
    emoji: be
  },
  marks: {
    bold: ke,
    strike: $e,
    underline: ve,
    strong: we,
    code: Te,
    italic: Re,
    link: _e,
    styled: Ee,
    subscript: Se,
    superscript: je,
    anchor: Ie,
    highlight: xe,
    textStyle: Ae
  }
}, Le = function(n) {
  const e = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#39;"
  }, t = /[&<>"']/g, r = new RegExp(t.source);
  return n && r.test(n) ? n.replace(t, (s) => e[s]) : n;
};
let z = !1;
class C {
  constructor(e) {
    g(this, "marks"), g(this, "nodes"), e || (e = Oe), this.marks = e.marks || [], this.nodes = e.nodes || [];
  }
  addNode(e, t) {
    this.nodes[e] = t;
  }
  addMark(e, t) {
    this.marks[e] = t;
  }
  render(e, t = { optimizeImages: !1 }, r = !0) {
    if (!z && r && (console.warn(
      "Warning ⚠️: The RichTextResolver class is deprecated and will be removed in the next major release. Please use the `@storyblok/richtext` package instead. https://github.com/storyblok/richtext/"
    ), z = !0), e && e.content && Array.isArray(e.content)) {
      let s = "";
      return e.content.forEach((o) => {
        s += this.renderNode(o);
      }), t.optimizeImages ? this.optimizeImages(s, t.optimizeImages) : s;
    }
    return console.warn(
      `The render method must receive an Object with a "content" field.
      The "content" field must be an array of nodes as the type ISbRichtext.
      ISbRichtext:
        content?: ISbRichtext[]
        marks?: ISbRichtext[]
        attrs?: any
        text?: string
        type: string
        
        Example:
        {
          content: [
            {
              content: [
                {
                  text: 'Hello World',
                  type: 'text'
                }
              ],
              type: 'paragraph'
            }
          ],
          type: 'doc'
        }`
    ), "";
  }
  optimizeImages(e, t) {
    let r = 0, s = 0, o = "", a = "";
    typeof t != "boolean" && (typeof t.width == "number" && t.width > 0 && (o += `width="${t.width}" `, r = t.width), typeof t.height == "number" && t.height > 0 && (o += `height="${t.height}" `, s = t.height), (t.loading === "lazy" || t.loading === "eager") && (o += `loading="${t.loading}" `), typeof t.class == "string" && t.class.length > 0 && (o += `class="${t.class}" `), t.filters && (typeof t.filters.blur == "number" && t.filters.blur >= 0 && t.filters.blur <= 100 && (a += `:blur(${t.filters.blur})`), typeof t.filters.brightness == "number" && t.filters.brightness >= -100 && t.filters.brightness <= 100 && (a += `:brightness(${t.filters.brightness})`), t.filters.fill && (t.filters.fill.match(/[0-9A-F]{6}/gi) || t.filters.fill === "transparent") && (a += `:fill(${t.filters.fill})`), t.filters.format && ["webp", "png", "jpeg"].includes(t.filters.format) && (a += `:format(${t.filters.format})`), typeof t.filters.grayscale == "boolean" && t.filters.grayscale && (a += ":grayscale()"), typeof t.filters.quality == "number" && t.filters.quality >= 0 && t.filters.quality <= 100 && (a += `:quality(${t.filters.quality})`), t.filters.rotate && [90, 180, 270].includes(t.filters.rotate) && (a += `:rotate(${t.filters.rotate})`), a.length > 0 && (a = `/filters${a}`))), o.length > 0 && (e = e.replace(/<img/g, `<img ${o.trim()}`));
    const l = r > 0 || s > 0 || a.length > 0 ? `${r}x${s}${a}` : "";
    return e = e.replace(
      /a.storyblok.com\/f\/(\d+)\/([^.]+)\.(gif|jpg|jpeg|png|tif|bmp)/g,
      `a.storyblok.com/f/$1/$2.$3/m/${l}`
    ), typeof t != "boolean" && (t.sizes || t.srcset) && (e = e.replace(/<img.*?src=["|'](.*?)["|']/g, (i) => {
      var h, d;
      const p = i.match(
        /a.storyblok.com\/f\/(\d+)\/([^.]+)\.(gif|jpg|jpeg|png|tif|bmp)/g
      );
      if (p && p.length > 0) {
        const b = {
          srcset: (h = t.srcset) == null ? void 0 : h.map((w) => {
            if (typeof w == "number")
              return `//${p}/m/${w}x0${a} ${w}w`;
            if (typeof w == "object" && w.length === 2) {
              let E = 0, j = 0;
              return typeof w[0] == "number" && (E = w[0]), typeof w[1] == "number" && (j = w[1]), `//${p}/m/${E}x${j}${a} ${E}w`;
            }
            return "";
          }).join(", "),
          sizes: (d = t.sizes) == null ? void 0 : d.map((w) => w).join(", ")
        };
        let k = "";
        return b.srcset && (k += `srcset="${b.srcset}" `), b.sizes && (k += `sizes="${b.sizes}" `), i.replace(/<img/g, `<img ${k.trim()}`);
      }
      return i;
    })), e;
  }
  renderNode(e) {
    const t = [];
    e.marks && e.marks.forEach((s) => {
      const o = this.getMatchingMark(s);
      o && o.tag !== "" && t.push(this.renderOpeningTag(o.tag));
    });
    const r = this.getMatchingNode(e);
    return r && r.tag && t.push(this.renderOpeningTag(r.tag)), e.content ? e.content.forEach((s) => {
      t.push(this.renderNode(s));
    }) : e.text ? t.push(Le(e.text)) : r && r.singleTag ? t.push(this.renderTag(r.singleTag, " /")) : r && r.html ? t.push(r.html) : e.type === "emoji" && t.push(this.renderEmoji(e)), r && r.tag && t.push(this.renderClosingTag(r.tag)), e.marks && e.marks.slice(0).reverse().forEach((s) => {
      const o = this.getMatchingMark(s);
      o && o.tag !== "" && t.push(this.renderClosingTag(o.tag));
    }), t.join("");
  }
  renderTag(e, t) {
    return e.constructor === String ? `<${e}${t}>` : e.map((r) => {
      if (r.constructor === String)
        return `<${r}${t}>`;
      {
        let s = `<${r.tag}`;
        if (r.attrs) {
          for (const o in r.attrs)
            if (Object.prototype.hasOwnProperty.call(r.attrs, o)) {
              const a = r.attrs[o];
              a !== null && (s += ` ${o}="${a}"`);
            }
        }
        return `${s}${t}>`;
      }
    }).join("");
  }
  renderOpeningTag(e) {
    return this.renderTag(e, "");
  }
  renderClosingTag(e) {
    return e.constructor === String ? `</${e}>` : e.slice(0).reverse().map((t) => t.constructor === String ? `</${t}>` : `</${t.tag}>`).join("");
  }
  getMatchingNode(e) {
    const t = this.nodes[e.type];
    if (typeof t == "function")
      return t(e);
  }
  getMatchingMark(e) {
    const t = this.marks[e.type];
    if (typeof t == "function")
      return t(e);
  }
  renderEmoji(e) {
    if (e.attrs.emoji)
      return e.attrs.emoji;
    const t = [
      {
        tag: "img",
        attrs: {
          src: e.attrs.fallbackImage,
          draggable: "false",
          loading: "lazy",
          align: "absmiddle"
        }
      }
    ];
    return this.renderTag(t, " /");
  }
}
class Ce {
  constructor(e) {
    g(this, "baseURL"), g(this, "timeout"), g(this, "headers"), g(this, "responseInterceptor"), g(this, "fetch"), g(this, "ejectInterceptor"), g(this, "url"), g(this, "parameters"), g(this, "fetchOptions"), this.baseURL = e.baseURL, this.headers = e.headers || new Headers(), this.timeout = e != null && e.timeout ? e.timeout * 1e3 : 0, this.responseInterceptor = e.responseInterceptor, this.fetch = (...t) => e.fetch ? e.fetch(...t) : fetch(...t), this.ejectInterceptor = !1, this.url = "", this.parameters = {}, this.fetchOptions = {};
  }
  /**
   *
   * @param url string
   * @param params ISbStoriesParams
   * @returns Promise<ISbResponse | Error>
   */
  get(e, t) {
    return this.url = e, this.parameters = t, this._methodHandler("get");
  }
  post(e, t) {
    return this.url = e, this.parameters = t, this._methodHandler("post");
  }
  put(e, t) {
    return this.url = e, this.parameters = t, this._methodHandler("put");
  }
  delete(e, t) {
    return this.url = e, this.parameters = t ?? {}, this._methodHandler("delete");
  }
  async _responseHandler(e) {
    const t = [], r = {
      data: {},
      headers: {},
      status: 0,
      statusText: ""
    };
    e.status !== 204 && await e.json().then((s) => {
      r.data = s;
    });
    for (const s of e.headers.entries())
      t[s[0]] = s[1];
    return r.headers = { ...t }, r.status = e.status, r.statusText = e.statusText, r;
  }
  async _methodHandler(e) {
    let t = `${this.baseURL}${this.url}`, r = null;
    if (e === "get") {
      const i = new L();
      t = `${this.baseURL}${this.url}?${i.stringify(
        this.parameters
      )}`;
    } else
      r = JSON.stringify(this.parameters);
    const s = new URL(t), o = new AbortController(), { signal: a } = o;
    let l;
    this.timeout && (l = setTimeout(() => o.abort(), this.timeout));
    try {
      const i = await this.fetch(`${s}`, {
        method: e,
        headers: this.headers,
        body: r,
        signal: a,
        ...this.fetchOptions
      });
      this.timeout && clearTimeout(l);
      const h = await this._responseHandler(
        i
      );
      return this.responseInterceptor && !this.ejectInterceptor ? this._statusHandler(this.responseInterceptor(h)) : this._statusHandler(h);
    } catch (i) {
      return {
        message: i
      };
    }
  }
  setFetchOptions(e = {}) {
    Object.keys(e).length > 0 && "method" in e && delete e.method, this.fetchOptions = { ...e };
  }
  eject() {
    this.ejectInterceptor = !0;
  }
  _statusHandler(e) {
    const t = /20[0-6]/g;
    return new Promise((r, s) => {
      if (t.test(`${e.status}`))
        return r(e);
      const o = {
        message: e.statusText,
        status: e.status,
        response: Array.isArray(e.data) ? e.data[0] : e.data.error || e.data.slug
      };
      s(o);
    });
  }
}
const D = "SB-Agent", N = {
  defaultAgentName: "SB-JS-CLIENT",
  defaultAgentVersion: "SB-Agent-Version",
  packageVersion: "6.0.0"
};
let A = {};
const S = {};
class Pe {
  /**
   *
   * @param config ISbConfig interface
   * @param pEndpoint string, optional
   */
  constructor(e, t) {
    g(this, "client"), g(this, "maxRetries"), g(this, "retriesDelay"), g(this, "throttle"), g(this, "accessToken"), g(this, "cache"), g(this, "helpers"), g(this, "resolveCounter"), g(this, "relations"), g(this, "links"), g(this, "richTextResolver"), g(this, "resolveNestedRelations"), g(this, "stringifiedStoriesCache");
    let r = e.endpoint || t;
    if (!r) {
      const a = new L().getRegionURL, l = e.https === !1 ? "http" : "https";
      e.oauthToken ? r = `${l}://${a(e.region)}/v1` : r = `${l}://${a(e.region)}/v2`;
    }
    const s = new Headers();
    s.set("Content-Type", "application/json"), s.set("Accept", "application/json"), e.headers && (e.headers.constructor.name === "Headers" ? e.headers.entries().toArray() : Object.entries(e.headers)).forEach(([a, l]) => {
      s.set(a, l);
    }), s.has(D) || (s.set(D, N.defaultAgentName), s.set(
      N.defaultAgentVersion,
      N.packageVersion
    ));
    let o = 5;
    e.oauthToken && (s.set("Authorization", e.oauthToken), o = 3), e.rateLimit && (o = e.rateLimit), e.richTextSchema ? this.richTextResolver = new C(e.richTextSchema) : this.richTextResolver = new C(), e.componentResolver && this.setComponentResolver(e.componentResolver), this.maxRetries = e.maxRetries || 10, this.retriesDelay = 300, this.throttle = oe(
      this.throttledRequest.bind(this),
      o,
      1e3
    ), this.accessToken = e.accessToken || "", this.relations = {}, this.links = {}, this.cache = e.cache || { clear: "manual" }, this.helpers = new L(), this.resolveCounter = 0, this.resolveNestedRelations = e.resolveNestedRelations || !0, this.stringifiedStoriesCache = {}, this.client = new Ce({
      baseURL: r,
      timeout: e.timeout || 0,
      headers: s,
      responseInterceptor: e.responseInterceptor,
      fetch: e.fetch
    });
  }
  setComponentResolver(e) {
    this.richTextResolver.addNode("blok", (t) => {
      let r = "";
      return t.attrs.body && t.attrs.body.forEach((s) => {
        r += e(s.component, s);
      }), {
        html: r
      };
    });
  }
  parseParams(e) {
    return e.token || (e.token = this.getToken()), e.cv || (e.cv = S[e.token]), Array.isArray(e.resolve_relations) && (e.resolve_relations = e.resolve_relations.join(",")), typeof e.resolve_relations < "u" && (e.resolve_level = 2), e;
  }
  factoryParamOptions(e, t) {
    return this.helpers.isCDNUrl(e) ? this.parseParams(t) : t;
  }
  makeRequest(e, t, r, s, o) {
    const a = this.factoryParamOptions(
      e,
      this.helpers.getOptionsPage(t, r, s)
    );
    return this.cacheResponse(e, a, void 0, o);
  }
  get(e, t, r) {
    t || (t = {});
    const s = `/${e}`, o = this.factoryParamOptions(s, t);
    return this.cacheResponse(s, o, void 0, r);
  }
  async getAll(e, t, r, s) {
    const o = (t == null ? void 0 : t.per_page) || 25, a = `/${e}`.replace(/\/$/, ""), l = r ?? a.substring(a.lastIndexOf("/") + 1), i = 1, h = await this.makeRequest(
      a,
      t,
      o,
      i,
      s
    ), d = h.total ? Math.ceil(h.total / o) : 1, p = await this.helpers.asyncMap(
      this.helpers.range(i, d),
      (b) => this.makeRequest(a, t, o, b + 1, s)
    );
    return this.helpers.flatMap([h, ...p], (b) => Object.values(b.data[l]));
  }
  post(e, t, r) {
    const s = `/${e}`;
    return Promise.resolve(
      this.throttle("post", s, t, r)
    );
  }
  put(e, t, r) {
    const s = `/${e}`;
    return Promise.resolve(
      this.throttle("put", s, t, r)
    );
  }
  delete(e, t, r) {
    t || (t = {});
    const s = `/${e}`;
    return Promise.resolve(
      this.throttle("delete", s, t, r)
    );
  }
  getStories(e, t) {
    return this._addResolveLevel(e), this.get("cdn/stories", e, t);
  }
  getStory(e, t, r) {
    return this._addResolveLevel(t), this.get(`cdn/stories/${e}`, t, r);
  }
  getToken() {
    return this.accessToken;
  }
  ejectInterceptor() {
    this.client.eject();
  }
  _addResolveLevel(e) {
    typeof e.resolve_relations < "u" && (e.resolve_level = 2);
  }
  _cleanCopy(e) {
    return JSON.parse(JSON.stringify(e));
  }
  _insertLinks(e, t, r) {
    const s = e[t];
    s && s.fieldtype === "multilink" && s.linktype === "story" && typeof s.id == "string" && this.links[r][s.id] ? s.story = this._cleanCopy(this.links[r][s.id]) : s && s.linktype === "story" && typeof s.uuid == "string" && this.links[r][s.uuid] && (s.story = this._cleanCopy(this.links[r][s.uuid]));
  }
  /**
   *
   * @param resolveId A counter number as a string
   * @param uuid The uuid of the story
   * @returns string | object
   */
  getStoryReference(e, t) {
    return this.relations[e][t] ? JSON.parse(this.stringifiedStoriesCache[t] || JSON.stringify(this.relations[e][t])) : t;
  }
  /**
   * Resolves a field's value by replacing UUIDs with their corresponding story references
   * @param jtree - The JSON tree object containing the field to resolve
   * @param treeItem - The key of the field to resolve
   * @param resolveId - The unique identifier for the current resolution context
   *
   * This method handles both single string UUIDs and arrays of UUIDs:
   * - For single strings: directly replaces the UUID with the story reference
   * - For arrays: maps through each UUID and replaces with corresponding story references
   */
  _resolveField(e, t, r) {
    const s = e[t];
    typeof s == "string" ? e[t] = this.getStoryReference(r, s) : Array.isArray(s) && (e[t] = s.map(
      (o) => this.getStoryReference(r, o)
    ).filter(Boolean));
  }
  /**
   * Inserts relations into the JSON tree by resolving references
   * @param jtree - The JSON tree object to process
   * @param treeItem - The current field being processed
   * @param fields - The relation patterns to resolve (string or array of strings)
   * @param resolveId - The unique identifier for the current resolution context
   *
   * This method handles two types of relation patterns:
   * 1. Nested relations: matches fields that end with the current field name
   *    Example: If treeItem is "event_type", it matches patterns like "*.event_type"
   *
   * 2. Direct component relations: matches exact component.field patterns
   *    Example: "event.event_type" for component "event" and field "event_type"
   *
   * The method supports both string and array formats for the fields parameter,
   * allowing flexible specification of relation patterns.
   */
  _insertRelations(e, t, r, s) {
    if (Array.isArray(r) ? r.find((a) => a.endsWith(`.${t}`)) : r.endsWith(`.${t}`)) {
      this._resolveField(e, t, s);
      return;
    }
    const o = e.component ? `${e.component}.${t}` : t;
    (Array.isArray(r) ? r.includes(o) : r === o) && this._resolveField(e, t, s);
  }
  /**
   * Recursively traverses and resolves relations in the story content tree
   * @param story - The story object containing the content to process
   * @param fields - The relation patterns to resolve
   * @param resolveId - The unique identifier for the current resolution context
   */
  iterateTree(e, t, r) {
    const s = (o, a = "") => {
      if (!(!o || o._stopResolving)) {
        if (Array.isArray(o))
          o.forEach((l, i) => s(l, `${a}[${i}]`));
        else if (typeof o == "object")
          for (const l in o) {
            const i = a ? `${a}.${l}` : l;
            (o.component && o._uid || o.type === "link") && (this._insertRelations(o, l, t, r), this._insertLinks(o, l, r)), s(o[l], i);
          }
      }
    };
    s(e.content);
  }
  async resolveLinks(e, t, r) {
    let s = [];
    if (e.link_uuids) {
      const o = e.link_uuids.length, a = [], l = 50;
      for (let i = 0; i < o; i += l) {
        const h = Math.min(o, i + l);
        a.push(e.link_uuids.slice(i, h));
      }
      for (let i = 0; i < a.length; i++)
        (await this.getStories({
          per_page: l,
          language: t.language,
          version: t.version,
          starts_with: t.starts_with,
          by_uuids: a[i].join(",")
        })).data.stories.forEach(
          (h) => {
            s.push(h);
          }
        );
    } else
      s = e.links;
    s.forEach((o) => {
      this.links[r][o.uuid] = {
        ...o,
        _stopResolving: !0
      };
    });
  }
  async resolveRelations(e, t, r) {
    let s = [];
    if (e.rel_uuids) {
      const o = e.rel_uuids.length, a = [], l = 50;
      for (let i = 0; i < o; i += l) {
        const h = Math.min(o, i + l);
        a.push(e.rel_uuids.slice(i, h));
      }
      for (let i = 0; i < a.length; i++)
        (await this.getStories({
          per_page: l,
          language: t.language,
          version: t.version,
          starts_with: t.starts_with,
          by_uuids: a[i].join(","),
          excluding_fields: t.excluding_fields
        })).data.stories.forEach((h) => {
          s.push(h);
        });
    } else
      s = e.rels;
    s && s.length > 0 && s.forEach((o) => {
      this.relations[r][o.uuid] = {
        ...o,
        _stopResolving: !0
      };
    });
  }
  /**
   *
   * @param responseData
   * @param params
   * @param resolveId
   * @description Resolves the relations and links of the stories
   * @returns Promise<void>
   *
   */
  async resolveStories(e, t, r) {
    var s, o;
    let a = [];
    if (this.links[r] = {}, this.relations[r] = {}, typeof t.resolve_relations < "u" && t.resolve_relations.length > 0 && (typeof t.resolve_relations == "string" && (a = t.resolve_relations.split(",")), await this.resolveRelations(e, t, r)), t.resolve_links && ["1", "story", "url", "link"].includes(t.resolve_links) && ((s = e.links) != null && s.length || (o = e.link_uuids) != null && o.length) && await this.resolveLinks(e, t, r), this.resolveNestedRelations)
      for (const l in this.relations[r])
        this.iterateTree(
          this.relations[r][l],
          a,
          r
        );
    e.story ? this.iterateTree(e.story, a, r) : e.stories.forEach((l) => {
      this.iterateTree(l, a, r);
    }), this.stringifiedStoriesCache = {}, delete this.links[r], delete this.relations[r];
  }
  async cacheResponse(e, t, r, s) {
    const o = this.helpers.stringify({ url: e, params: t }), a = this.cacheProvider();
    if (t.version === "published" && e !== "/cdn/spaces/me") {
      const l = await a.get(o);
      if (l)
        return Promise.resolve(l);
    }
    return new Promise(async (l, i) => {
      var h;
      try {
        const d = await this.throttle(
          "get",
          e,
          t,
          s
        );
        if (d.status !== 200)
          return i(d);
        let p = { data: d.data, headers: d.headers };
        if ((h = d.headers) != null && h["per-page"] && (p = Object.assign({}, p, {
          perPage: d.headers["per-page"] ? Number.parseInt(d.headers["per-page"]) : 0,
          total: d.headers["per-page"] ? Number.parseInt(d.headers.total) : 0
        })), p.data.story || p.data.stories) {
          const k = this.resolveCounter = ++this.resolveCounter % 1e3;
          await this.resolveStories(p.data, t, `${k}`);
        }
        t.version === "published" && e !== "/cdn/spaces/me" && await a.set(o, p);
        const b = this.cache.clear === "onpreview" && t.version === "draft" || this.cache.clear === "auto";
        return t.token && p.data.cv && (b && S[t.token] && S[t.token] !== p.data.cv && await this.flushCache(), S[t.token] = p.data.cv), l(p);
      } catch (d) {
        if (d.response && d.status === 429 && (r = typeof r > "u" ? 0 : r + 1, r < this.maxRetries))
          return console.log(
            `Hit rate limit. Retrying in ${this.retriesDelay / 1e3} seconds.`
          ), await this.helpers.delay(this.retriesDelay), this.cacheResponse(e, t, r).then(l).catch(i);
        i(d);
      }
    });
  }
  throttledRequest(e, t, r, s) {
    return this.client.setFetchOptions(s), this.client[e](t, r);
  }
  cacheVersions() {
    return S;
  }
  cacheVersion() {
    return S[this.accessToken];
  }
  setCacheVersion(e) {
    this.accessToken && (S[this.accessToken] = e);
  }
  clearCacheVersion() {
    this.accessToken && (S[this.accessToken] = 0);
  }
  cacheProvider() {
    switch (this.cache.type) {
      case "memory":
        return {
          get(e) {
            return Promise.resolve(A[e]);
          },
          getAll() {
            return Promise.resolve(A);
          },
          set(e, t) {
            return A[e] = t, Promise.resolve(void 0);
          },
          flush() {
            return A = {}, Promise.resolve(void 0);
          }
        };
      case "custom":
        if (this.cache.custom)
          return this.cache.custom;
      // eslint-disable-next-line no-fallthrough
      default:
        return {
          get() {
            return Promise.resolve();
          },
          getAll() {
            return Promise.resolve(void 0);
          },
          set() {
            return Promise.resolve(void 0);
          },
          flush() {
            return Promise.resolve(void 0);
          }
        };
    }
  }
  async flushCache() {
    return await this.cacheProvider().flush(), this.clearCacheVersion(), this;
  }
}
const De = (n = {}) => {
  const { apiOptions: e } = n;
  if (!e || !e.accessToken) {
    console.error(
      "You need to provide an access token to interact with Storyblok API. Read https://www.storyblok.com/docs/api/content-delivery#topics/authentication"
    );
    return;
  }
  return { storyblokApi: new Pe(e) };
}, qe = (n) => {
  if (typeof n != "object" || typeof n._editable > "u")
    return {};
  try {
    const e = JSON.parse(
      n._editable.replace(/^<!--#storyblok#/, "").replace(/-->$/, "")
    );
    return e ? {
      "data-blok-c": JSON.stringify(e),
      "data-blok-uid": `${e.id}-${e.uid}`
    } : {};
  } catch {
    return {};
  }
};
function Ne(n, e) {
  if (!e)
    return { src: n, attrs: {} };
  let t = 0, r = 0;
  const s = {}, o = [];
  function a(i, h, d, p, b) {
    typeof i != "number" || i <= h || i >= d ? console.warn(`[StoryblokRichText] - ${p.charAt(0).toUpperCase() + p.slice(1)} value must be a number between ${h} and ${d} (inclusive)`) : b.push(`${p}(${i})`);
  }
  if (typeof e == "object") {
    if (typeof e.width == "number" && e.width > 0 ? (s.width = e.width, t = e.width) : console.warn("[StoryblokRichText] - Width value must be a number greater than 0"), e.height && typeof e.height == "number" && e.height > 0 ? (s.height = e.height, r = e.height) : console.warn("[StoryblokRichText] - Height value must be a number greater than 0"), e.loading && ["lazy", "eager"].includes(e.loading) && (s.loading = e.loading), e.class && (s.class = e.class), e.filters) {
      const { filters: i } = e || {}, { blur: h, brightness: d, fill: p, format: b, grayscale: k, quality: w, rotate: E } = i || {};
      h && a(h, 0, 100, "blur", o), w && a(w, 0, 100, "quality", o), d && a(d, 0, 100, "brightness", o), p && o.push(`fill(${p})`), k && o.push("grayscale()"), E && [0, 90, 180, 270].includes(e.filters.rotate || 0) && o.push(`rotate(${E})`), b && ["webp", "png", "jpeg"].includes(b) && o.push(`format(${b})`);
    }
    e.srcset && (s.srcset = e.srcset.map((i) => {
      if (typeof i == "number")
        return `${n}/m/${i}x0/${o.length > 0 ? `filters:${o.join(":")}` : ""} ${i}w`;
      if (Array.isArray(i) && i.length === 2) {
        const [h, d] = i;
        return `${n}/m/${h}x${d}/${o.length > 0 ? `filters:${o.join(":")}` : ""} ${h}w`;
      } else {
        console.warn("[StoryblokRichText] - srcset entry must be a number or a tuple of two numbers");
        return;
      }
    }).join(", ")), e.sizes && (s.sizes = e.sizes.join(", "));
  }
  let l = `${n}/m/`;
  return t > 0 && r > 0 && (l = `${l}${t}x${r}/`), o.length > 0 && (l = `${l}filters:${o.join(":")}`), {
    src: l,
    attrs: s
  };
}
var v = /* @__PURE__ */ ((n) => (n.DOCUMENT = "doc", n.HEADING = "heading", n.PARAGRAPH = "paragraph", n.QUOTE = "blockquote", n.OL_LIST = "ordered_list", n.UL_LIST = "bullet_list", n.LIST_ITEM = "list_item", n.CODE_BLOCK = "code_block", n.HR = "horizontal_rule", n.BR = "hard_break", n.IMAGE = "image", n.EMOJI = "emoji", n.COMPONENT = "blok", n.TABLE = "table", n.TABLE_ROW = "tableRow", n.TABLE_CELL = "tableCell", n.TABLE_HEADER = "tableHeader", n))(v || {}), _ = /* @__PURE__ */ ((n) => (n.BOLD = "bold", n.STRONG = "strong", n.STRIKE = "strike", n.UNDERLINE = "underline", n.ITALIC = "italic", n.CODE = "code", n.LINK = "link", n.ANCHOR = "anchor", n.STYLED = "styled", n.SUPERSCRIPT = "superscript", n.SUBSCRIPT = "subscript", n.TEXT_STYLE = "textStyle", n.HIGHLIGHT = "highlight", n))(_ || {}), G = /* @__PURE__ */ ((n) => (n.TEXT = "text", n))(G || {}), I = /* @__PURE__ */ ((n) => (n.URL = "url", n.STORY = "story", n.ASSET = "asset", n.EMAIL = "email", n))(I || {});
const He = [
  "area",
  "base",
  "br",
  "col",
  "embed",
  "hr",
  "img",
  "input",
  "link",
  "meta",
  "param",
  "source",
  "track",
  "wbr"
], Me = (n = {}) => Object.keys(n).map((e) => `${e}="${n[e]}"`).join(" "), Ue = (n = {}) => Object.keys(n).map((e) => `${e}: ${n[e]}`).join("; ");
function Be(n) {
  return n.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#039;");
}
const O = (n) => Object.fromEntries(Object.entries(n).filter(([e, t]) => t !== void 0));
function q(n, e = {}, t) {
  const r = Me(e), s = r ? `${n} ${r}` : n, o = Array.isArray(t) ? t.join("") : t || "";
  if (n) {
    if (He.includes(n))
      return `<${s}>`;
  } else return o;
  return `<${s}>${o}</${n}>`;
}
function Fe(n = {}) {
  let e = 0;
  const {
    renderFn: t = q,
    textFn: r = Be,
    resolvers: s = {},
    optimizeImages: o = !1,
    keyedResolvers: a = !1
  } = n, l = t !== q, i = (c) => (u) => {
    const f = u.attrs || {};
    return a && (f.key = `${c}-${e}`), t(c, f, u.children || null);
  }, h = (c) => {
    const { src: u, alt: f, title: y, srcset: R, sizes: $ } = c.attrs || {};
    let m = u, T = {};
    if (o) {
      const { src: ee, attrs: te } = Ne(u, o);
      m = ee, T = te;
    }
    a && (T = {
      ...T,
      key: `img-${e}`
    });
    const Z = {
      src: m,
      alt: f,
      title: y,
      srcset: R,
      sizes: $,
      ...T
    };
    return t("img", O(Z));
  }, d = (c) => {
    const { level: u, ...f } = c.attrs || {}, y = {
      ...f
    };
    return a && (y.key = `h${u}-${e}`), t(`h${u}`, y, c.children);
  }, p = (c) => {
    var u, f, y, R;
    const $ = t("img", {
      src: (u = c.attrs) == null ? void 0 : u.fallbackImage,
      alt: (f = c.attrs) == null ? void 0 : f.alt,
      style: "width: 1.25em; height: 1.25em; vertical-align: text-top",
      draggable: "false",
      loading: "lazy"
    }), m = {
      "data-type": "emoji",
      "data-name": (y = c.attrs) == null ? void 0 : y.name,
      "data-emoji": (R = c.attrs) == null ? void 0 : R.emoji
    };
    return a && (m.key = `emoji-${e}`), t("span", m, $);
  }, b = (c) => t("pre", {
    ...c.attrs,
    key: `code-${e}`
  }, t("code", { key: `code-${e}` }, c.children || "")), k = (c, u = !1) => ({ text: f, attrs: y }) => {
    const { class: R, id: $, ...m } = y || {}, T = u ? {
      class: R,
      id: $,
      style: Ue(m) || void 0
    } : y || {};
    return a && (T.key = `${c}-${e}`), t(c, O(T), f);
  }, w = (c) => P(c), E = (c) => {
    const { marks: u, ...f } = c;
    return "text" in c ? u ? u.reduce(
      (y, R) => w({ ...R, text: y }),
      // Fix: Ensure render function returns a string
      w({ ...f, children: f.children })
      // Fix: Cast children to string
    ) : r(f.text) : "";
  }, j = (c) => {
    const { linktype: u, href: f, anchor: y, ...R } = c.attrs || {};
    let $ = "";
    switch (u) {
      case I.ASSET:
      case I.URL:
        $ = f;
        break;
      case I.EMAIL:
        $ = `mailto:${f}`;
        break;
      case I.STORY:
        $ = f, y && ($ = `${$}#${y}`);
        break;
      default:
        $ = f;
        break;
    }
    const m = { ...R };
    return $ && (m.href = $), a && (m.key = `a-${e}`), t("a", m, c.text);
  }, J = (c) => {
    var u, f;
    return console.warn("[StoryblokRichtText] - BLOK resolver is not available for vanilla usage"), t("span", {
      blok: (u = c == null ? void 0 : c.attrs) == null ? void 0 : u.body[0],
      id: (f = c.attrs) == null ? void 0 : f.id,
      key: `component-${e}`,
      style: "display: none"
    });
  }, K = (c) => {
    const u = {};
    return a && (u.key = `table-${e}`), t("table", u, c.children);
  }, Y = (c) => {
    const u = {};
    return a && (u.key = `tr-${e}`), t("tr", u, c.children);
  }, W = (c) => {
    const { colspan: u, rowspan: f, colwidth: y, backgroundColor: R, ...$ } = c.attrs || {}, m = {
      ...$
    };
    u > 1 && (m.colspan = u), f > 1 && (m.rowspan = f);
    const T = [];
    return y && T.push(`width: ${y}px;`), R && T.push(`background-color: ${R};`), T.length > 0 && (m.style = T.join(" ")), a && (m.key = `td-${e}`), t("td", O(m), c.children);
  }, X = (c) => {
    const { colspan: u, rowspan: f, colwidth: y, backgroundColor: R, ...$ } = c.attrs || {}, m = {
      ...$
    };
    u > 1 && (m.colspan = u), f > 1 && (m.rowspan = f);
    const T = [];
    return y && T.push(`width: ${y}px;`), R && T.push(`background-color: ${R};`), T.length > 0 && (m.style = T.join(" ")), a && (m.key = `th-${e}`), t("th", O(m), c.children);
  }, Q = new Map([
    [v.DOCUMENT, i("")],
    [v.HEADING, d],
    [v.PARAGRAPH, i("p")],
    [v.UL_LIST, i("ul")],
    [v.OL_LIST, i("ol")],
    [v.LIST_ITEM, i("li")],
    [v.IMAGE, h],
    [v.EMOJI, p],
    [v.CODE_BLOCK, b],
    [v.HR, i("hr")],
    [v.BR, i("br")],
    [v.QUOTE, i("blockquote")],
    [v.COMPONENT, J],
    [G.TEXT, E],
    [_.LINK, j],
    [_.ANCHOR, j],
    [_.STYLED, k("span", !0)],
    [_.BOLD, k("strong")],
    [_.TEXT_STYLE, k("span", !0)],
    [_.ITALIC, k("em")],
    [_.UNDERLINE, k("u")],
    [_.STRIKE, k("s")],
    [_.CODE, k("code")],
    [_.SUPERSCRIPT, k("sup")],
    [_.SUBSCRIPT, k("sub")],
    [_.HIGHLIGHT, k("mark")],
    [v.TABLE, K],
    [v.TABLE_ROW, Y],
    [v.TABLE_CELL, W],
    [v.TABLE_HEADER, X],
    ...Object.entries(s).map(([c, u]) => [c, u])
  ]);
  function x(c) {
    e += 1;
    const u = Q.get(c.type);
    if (!u)
      return console.error("<Storyblok>", `No resolver found for node type ${c.type}`), "";
    if (c.type === "text")
      return u(c);
    const f = c.content ? c.content.map(P) : void 0;
    return u({
      ...c,
      children: f
      // Fix: Update the type of 'children' to Node[]
    });
  }
  function P(c) {
    return c.type === "doc" ? l ? c.content.map(x) : c.content.map(x).join("") : Array.isArray(c) ? c.map(x) : x(c);
  }
  return {
    render: P
  };
}
let H, M = "https://app.storyblok.com/f/storyblok-v2-latest.js";
const Ge = (n, e, t = {}) => {
  var r;
  const s = !(typeof window > "u") && typeof window.storyblokRegisterEvent < "u", o = new URL((r = window.location) == null ? void 0 : r.href).searchParams.get(
    "_storyblok"
  ), a = o !== null && +o === n;
  if (!(!s || !a)) {
    if (!n) {
      console.warn("Story ID is not defined. Please provide a valid ID.");
      return;
    }
    window.storyblokRegisterEvent(() => {
      new window.StoryblokBridge(t).on(["input", "published", "change"], (l) => {
        var i;
        l && (l.action === "input" && ((i = l.story) == null ? void 0 : i.id) === n ? e(l.story) : (l.action === "change" || l.action === "published") && l.storyId === n && window.location.reload());
      });
    });
  }
}, V = (n, e) => {
  n.addNode("blok", (t) => {
    let r = "";
    return t.attrs.body.forEach((s) => {
      r += e(s.component, s);
    }), {
      html: r
    };
  });
}, Ve = (n = {}) => {
  var e, t;
  const {
    bridge: r,
    accessToken: s,
    use: o = [],
    apiOptions: a = {},
    richText: l = {},
    bridgeUrl: i
  } = n;
  a.accessToken = a.accessToken || s;
  const h = { bridge: r, apiOptions: a };
  let d = {};
  o.forEach((b) => {
    d = { ...d, ...b(h) };
  }), i && (M = i);
  const p = !(typeof window > "u") && ((t = (e = window.location) == null ? void 0 : e.search) == null ? void 0 : t.includes("_storyblok_tk"));
  return r !== !1 && p && F(M), H = new C(l.schema), l.resolver && V(H, l.resolver), d;
}, ze = (n) => {
  var e;
  return !n || !((e = n == null ? void 0 : n.content) != null && e.some((t) => t.content || t.type === "blok" || t.type === "horizontal_rule"));
}, Je = (n, e, t) => {
  let r = t || H;
  if (!r) {
    console.error(
      "Please initialize the Storyblok SDK before calling the renderRichText function"
    );
    return;
  }
  return ze(n) ? "" : (e && (r = new C(e.schema), e.resolver && V(r, e.resolver)), r.render(n, {}, !1));
}, Ke = () => F(M);
export {
  v as BlockTypes,
  _ as MarkTypes,
  C as RichTextResolver,
  Oe as RichTextSchema,
  G as TextTypes,
  De as apiPlugin,
  ze as isRichTextEmpty,
  Ke as loadStoryblokBridge,
  Ge as registerStoryblokBridge,
  Je as renderRichText,
  Fe as richTextResolver,
  qe as storyblokEditable,
  Ve as storyblokInit,
  Ge as useStoryblokBridge
};
